import { useContext, useMemo } from "react";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import ModuleSideNav from "../../shared/ModuleSideNav";
import { useColorMode } from "../../../contexts/ColorModeContext";
import { AuthContext } from "../../../Auth/AuthProvider";
import {
  VerifyAnyPermission,
  VerifyPermission,
} from "../../../Funcoes/VerifyPermission";
import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
  NAV_ITEMS,
} from "./navConfig";

const ICONS = {
  Search: ManageSearchOutlinedIcon,
  Dashboard: SpaceDashboardOutlinedIcon,
  Inventory: FormatListBulletedOutlinedIcon,
  Add: NoteAddOutlinedIcon,
  Warehouse: MoveToInboxOutlinedIcon,
  Account: RuleOutlinedIcon,
  Check: TaskAltOutlinedIcon,
};

const canSeeNavItem = (user, item) => {
  if (item.disabled) return false;
  if (item.permission && !VerifyPermission(user, item.permission)) return false;
  if (item.anyPermission && !VerifyAnyPermission(user, item.anyPermission)) {
    return false;
  }
  return true;
};

const CadastrosMuiNav = (props) => {
  const { mode, toggleColorMode } = useColorMode();
  const { user } = useContext(AuthContext);

  const navItems = useMemo(
    () => NAV_ITEMS.filter((item) => canSeeNavItem(user, item)),
    [user]
  );

  return (
    <ModuleSideNav
      moduleTitle="Cadastros"
      navItems={navItems}
      iconMap={ICONS}
      drawerWidth={DRAWER_WIDTH}
      drawerWidthCollapsed={DRAWER_WIDTH_COLLAPSED}
      getNavLinkEnd={(item) => item.path === "/modulo/cadastros/produtos"}
      mode={mode}
      toggleColorMode={toggleColorMode}
      {...props}
    />
  );
};

export default CadastrosMuiNav;
